import "../pages.scss";
import { TallesState } from '../../context/talles/TallesState';
import Datatable from "./tallesTable/Datatable"

const TallesPage = () => { 
  return (
    <>
      <TallesState>
        <Datatable />
      </TallesState>
    </>
  )
}

export default TallesPage